import { SensorType } from "./shared.js";
import { SensorConfigurations } from "./Configurations/SensorConfigurations/SensorConfiguration.js";

const listOfAllDataTypes = [
    "valveState",
    "irrigationAmount",
    "avgNDVI",
    "ndviVariance",
    "valveOpenPercent",
    "zoneIrrigationScheduled",
    "dailyIrrigationAmount",
    "rainfallAmount",
    "temperature",
    "humidity",
    "packetDrop",
    "saplingResetCount",
    "v1flowmeter",
    "v1flowmeter_1",
    "v1flowmeter_2",
    "precipitation",
    "saplingBattery",
    "v1transducer",
    "isOnline",
    "saplingVerification",
    "saplingRawSensor_1",
    "saplingRawSensor_2",
    "saplingRawSensor_3",
    "saplingRawSensor_4",
    "saplingRawSensor_5",
    "saplingRawSensor_6",
    "saplingRawSensor_7",
    "BETA_accelerometer_x",
    "BETA_accelerometer_y",
    "BETA_accelerometer_z",
    "accelerometerRMS",
    "uplinkPacketLoss",
    "sproutResetCount",
    "sproutCrashCount",
    "batteryVoltage",
    "sproutPacketInfo",
    "draginoEC",
    "uplinkFrameCount",
    "soilTemperature",
    "valveOnlinePercent",
    "windSpeed",
    "windHeading",
    "waterTankLevel",

    "moisture_vol",
    "draginoECMoisture",
    "moisture_watermark",
    "moisture_irrometer",
    "moisture_drillAndDrop",
    "moisture",
    "moisture2",
    "voltage",

    "salinity_drillAndDrop",

    "gen4ResetCount",
    "gen4CrashCount",
    "gen4LastErrorCode",
    "gen4FlowPulseTotal",
    "gen4SolenoidVerification",
    "gen4ValvePulseRecord",
    "stemWaterPotential", // also known as Stem Water Potential (SWP)

    // Generic sensor-port system types — replace the generation-specific variants above
    // for data flowing through the new cluster-based port architecture.
    "crashCount",
    "resetCount",
    // "as const" marks that this list will not be altered at all after compile time and
    // allows generation of a type based on a list of values.
] as const;

// sets ParsedDataTypeSpecifier to be anything indexable by a number in listOfAllDataTypes
export type ParsedDataTypeSpecifier = (typeof listOfAllDataTypes)[number];

// creates a type that allows the "RAW_" prefix to be added to any ParsedDataTypeSpecifier to create a RAW one
export type RawDataTypeSpecifier = `${"RAW_"}${SensorType}`;

export type DataTypeSpecifier = ParsedDataTypeSpecifier | RawDataTypeSpecifier;

export const allParsedDataTypes: ParsedDataTypeSpecifier[] = [...listOfAllDataTypes];

export const allRawDataTypes: RawDataTypeSpecifier[] = Object.keys(SensorConfigurations).map(
    (sensorType: SensorType): RawDataTypeSpecifier => `RAW_${sensorType}`,
);

export enum DataFormatSpecifierEnum {
    number = "number",
    boolean = "boolean",
    enum = "enum",
    packetDrop = "packetDrop",
    valveState = "valveState",
    verification = "verification",
    sproutPacketInfo = "sproutPacketInfo",
}
